import {
  call,
  put,
  takeLatest
} from "redux-saga/effects";
import {
  schema
} from "normalizr";
import {
  authorizedRequest
} from "utils/api";
import {
  ToastSuccess,
  ToastError
} from "components/Global/Toasts/Toasty";

export const USERS_GET_REQUEST = "USERS_GET_REQUEST";
export const USERS_GET_FAILURE = "USERS_GET_FAILURE";
export const USERS_GET_SUCCESS = "USERS_GET_SUCCESS";

export const USER_GET_REQUEST = "USER_GET_REQUEST";
export const USER_GET_FAILURE = "USER_GET_FAILURE";
export const USER_GET_SUCCESS = "USER_GET_SUCCESS";

export const ROLES_GET_REQUEST = "ROLES_GET_REQUEST";
export const ROLES_GET_FAILURE = "ROLES_GET_FAILURE";
export const ROLES_GET_SUCCESS = "ROLES_GET_SUCCESS";

export const USER_CREATE_REQUEST = "USER_CREATE_REQUEST";
export const USER_CREATE_FAILURE = "USER_CREATE_FAILURE";
export const USER_CREATE_SUCCESS = "USER_CREATE_SUCCESS";

export const USER_UPDATE_REQUEST = "USER_UPDATE_REQUEST";
export const USER_UPDATE_FAILURE = "USER_UPDATE_FAILURE";
export const USER_UPDATE_SUCCESS = "USER_UPDATE_SUCCESS";

export const USER_CHANGE_PASS_REQUEST = "USER_CHANGE_PASS_REQUEST";
export const USER_CHANGE_PASS_SUCCESS = "USER_CHANGE_PASS_SUCCESS";
export const USER_CHANGE_PASS_FAILURE = "USER_CHANGE_PASS_FAILURE";

export const USERS_KEY = "users";
export const USERS_ENTITY = new schema.Entity(USERS_KEY, {});
export const USERS_SCHEMA = [USERS_ENTITY];

const initialState = {
  error: ""
};

export default function usersReducer(state = initialState, action) {
  const {
    type,
    payload
  } = action;
  switch (type) {
    case USERS_GET_SUCCESS:
      return {
        ...state,
        ...payload,
        error: ""
      };

    case USER_GET_SUCCESS:
      return {
        ...state,
        user: payload.user,
        error: ""
      };

    case ROLES_GET_SUCCESS:
      return {
        ...state,
        ...payload,
        roles: payload.roles,
        error: ""
      };

    case USER_CREATE_SUCCESS:
      ToastSuccess("Save successful");

      return {
        ...state,
        ...payload,
        user: payload.user,
        error: ""
      };

    case USER_CREATE_FAILURE:
      return {
        ...state,
        ...payload,
        error: action.error.response.data.error.user.email
      };

    case USER_UPDATE_SUCCESS:
      ToastSuccess("Save successful");

      return {
        ...state,
        ...payload,
        user: payload.user
      };

    case USER_CHANGE_PASS_SUCCESS:
      ToastSuccess("Password changed");

      return {
        ...state,
        ...payload
      };

    case USER_CHANGE_PASS_FAILURE:
      return {
        ...state,
        ...payload
      };

    default:
      return state;
  }
}

// GET Users
export function getUsers(payload) {
  return {
    type: USERS_GET_REQUEST,
    ...payload
  };
}
export function getUsersSuccess(payload) {
  return {
    type: USERS_GET_SUCCESS,
    payload
  };
}
export function getUsersFailure(error) {
  return {
    type: USERS_GET_FAILURE,
    error
  };
}

// GET User
export function getUser(payload) {
  return {
    type: USER_GET_REQUEST,
    payload
  };
}
export function getUserSuccess(payload) {
  return {
    type: USER_GET_SUCCESS,
    payload
  };
}
export function getUserFailure(error) {
  return {
    type: USER_GET_FAILURE,
    error
  };
}

// CREATE User
export function createUser(payload) {
  return {
    type: USER_CREATE_REQUEST,
    payload
  };
}
export function createUserSuccess(payload) {
  return {
    type: USER_CREATE_SUCCESS,
    payload
  };
}
export function createUserFailure(error) {
  return {
    type: USER_CREATE_FAILURE,
    error
  };
}

// UPDATE User
export function updateUser(payload) {
  return {
    type: USER_UPDATE_REQUEST,
    payload
  };
}
export function updateUserSuccess(payload) {
  return {
    type: USER_UPDATE_SUCCESS,
    payload
  };
}
export function updateUserFailure(error) {
  return {
    type: USER_UPDATE_FAILURE,
    error
  };
}

// GET Roles
export function getRoles(payload) {
  return {
    type: ROLES_GET_REQUEST,
    payload
  };
}
export function getRolesSuccess(payload) {
  return {
    type: ROLES_GET_SUCCESS,
    payload
  };
}
export function getRolesFailure(error) {
  return {
    type: ROLES_GET_FAILURE,
    error
  };
}
export function userChangePassRequest(payload) {
  return {
    type: USER_CHANGE_PASS_REQUEST,
    payload
  };
}
export function userChangePassSuccess(payload) {
  return {
    type: USER_CHANGE_PASS_SUCCESS,
    payload
  };
}
export function userChangePassFailure(error) {
  return {
    type: USER_CHANGE_PASS_FAILURE,
    payload: {
      error
    }
  };
}

// Saga GET Paginated Users
function* getPaginatedUsersSaga(payload) {
  try {
    let url = "/users";
    const {
      page,
      limit
    } = payload;
    // Add pagination params
    if (page !== null && limit !== null) {
      url = `${url}?page=${page + 1}&limit=${limit}`;
    }
    const response = yield call(authorizedRequest, url);
    yield put(getUsersSuccess(response));
  } catch (error) {
    yield put(getUsersFailure(error));
  }
}

// Saga GET User
function* getUserSaga(payload) {
  try {
    const response = yield call(
      authorizedRequest,
      `/users/${payload.payload.id}`,
      "GET"
    );
    yield put(getUserSuccess(response));
  } catch (error) {
    yield put(getUserFailure(error));
  }
}
// Saga CREATE User
function* createUserSaga(payload) {
  try {
    const response = yield call(authorizedRequest, "/users", "POST", {
      user: payload.payload
    });
    yield put(createUserSuccess(response));
  } catch (error) {
    yield put(createUserFailure(error));
  }
}
// Saga UPDATE User
function* updateUserSaga(payload) {
  try {
    const response = yield call(
      authorizedRequest,
      `/users/${payload.payload.id}`,
      "PUT",
      {
        user: payload.payload
      }
    );
    yield put(updateUserSuccess(response));
    // yield put(getUsers());
  } catch (error) {
    yield put(updateUserFailure(error));
  }
}
// Saga GET Roles
function* getRolesSaga() {
  try {
    const response = yield call(authorizedRequest, "/roles", "GET");
    yield put(getRolesSuccess(response));
  } catch (error) {
    yield put(getRolesFailure(error));
  }
}

function* changePassSaga(action) {
  try {
    const {
      payload
    } = action;
    const response = yield call(
      authorizedRequest,
      `/users/${payload.id}/changepassword`,
      "POST",
      payload.payload
    );
    yield put(userChangePassSuccess(response));
    ToastSuccess(response.success === false ? response.msg : "User password updated!");
  } catch (error) {
    yield put(userChangePassFailure(error));
    ToastError(error.message);
  }
}

export function* usersSaga() {
  yield takeLatest(USERS_GET_REQUEST, getPaginatedUsersSaga);
  yield takeLatest(USER_GET_REQUEST, getUserSaga);
  yield takeLatest(USER_CREATE_REQUEST, createUserSaga);
  yield takeLatest(ROLES_GET_REQUEST, getRolesSaga);
  yield takeLatest(USER_UPDATE_REQUEST, updateUserSaga);
  yield takeLatest(USER_CHANGE_PASS_REQUEST, changePassSaga);
}
